import type { ReactNode } from 'react';
import type { BombiixCellRendererParams, BombiixRow } from '../types';

interface TotalsFooterExtras {
  format?: (value: unknown, row: BombiixRow | undefined) => ReactNode;
  prefixLabel?: string | null;
  bold?: boolean;
}

type TotalsFooterCellProps = BombiixCellRendererParams & TotalsFooterExtras;

/**
 * Footer cell for pinnedBottomRowData. Renders nothing by default; consumers
 * pass `format(value, row)` to produce the display string.
 */
function TotalsFooterCell(params: TotalsFooterCellProps) {
  const { value, data, format, prefixLabel, bold = true } = params;
  if (value === undefined || value === null || value === '') return null;
  const rendered = typeof format === 'function' ? format(value, data) : (value as ReactNode);
  return (
    <span className={bold ? 'cag-totals-cell cag-totals-cell--bold' : 'cag-totals-cell'}>
      {prefixLabel ? `${prefixLabel} ` : null}
      {rendered}
    </span>
  );
}

export default TotalsFooterCell;
